import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// withCredentials so the browser sends the httpOnly session cookie on every request
export const api = axios.create({ baseURL: API, withCredentials: true });

// Migration: purge any legacy localStorage token from earlier builds.
try { localStorage.removeItem("kr_token"); localStorage.removeItem("kr_user"); } catch (_) {}

api.interceptors.request.use((config) => {
  // Legacy fallback (session-only). Cookie is the primary auth.
  const t = sessionStorage.getItem("kr_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Public routes: don't kidnap anonymous visitors from the landing page
      // (or the login page itself) just because /auth/me returned 401.
      const publicPaths = ["/", "/login", "/forgot-password", "/reset-password"];
      const isPublic = publicPaths.includes(path);
      if (!isPublic) {
        sessionStorage.removeItem("kr_token");
        sessionStorage.removeItem("kr_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const SCREEN_LABELS = {
  dashboard: "Dashboard",
  contact: "Enquiries",
  documents: "Documents",
  quotations: "Quotations",
  purchase_orders: "Purchase Orders",
  purchase_invoices: "Purchase Invoices",
  sales_invoices: "Sales Invoices",
  accounting: "Accounting",
  parties: "Customers & Suppliers",
  batches: "Batches",
  schedules: "Schedules",
  attendance: "Attendance",
  payroll: "Payroll",
  inventory: "Inventory",
  products: "Products",
  issues: "Issues",
  misc_purchases: "Misc Purchases",
  requests: "Requests",
  users: "Users",
  settings: "Settings",
  pnl: "Monthly P&L",
  barcodes: "Barcodes Overview",
  audit: "Audit Log",
  meetings: "Meetings & Calls",
  production: "Production Schedule",
  subscriptions: "Subscriptions",
  customers: "Customers",
  suppliers: "Suppliers",
};
